<template>
  <div class="u-input custom-number-input">
    <div class="u-input-box" :class="[{'is-not-valid': !number.isValid || inValid, 'disabled': disabled, 'force-value': forceValue, 'has-checkbox': number.hasOwnProperty('checked')}, classes || {}]" :style="getStyles" @click="$emit('clicked')">
<!--      <span class="input-label" :class="{'is-focus': number.value.toString().length || label.length}">{{ labelPlaceholder || label }}</span><div class="u-input-label-box">-->
      <div class="u-input-label-box">
        <div class="u-input-label-box-start"></div>
        <div v-if="labelPlaceholder || label" class="u-input-label-box-center" :class="[labelPosition]">
          <span class="u-input-label text-subtitle" :class="[{'is-focus': number.value.toString().length || label, 'text-body-1': labelPosition === 'inside'}]">{{ labelPlaceholder || label }}</span>
        </div>
        <div class="u-input-label-box-end"></div>
      </div>
      <div v-if="isInputDisable"
            class="disable-input-value disabled"
            :class="[{'text-primary has-link': Object.values(this.route).length > 0, 'input-disabled': (this.number.hasOwnProperty('checked') && this.checked)}, $vs.rtl ? 'dir-rtl' : 'dir-ltr']"
            @click="handleClickInput">
        {{ number.value || placeholder }}
      </div>
      <input v-else
             type="text"
             :class="[{'disabled': disabled, 'force-value': forceValue, 'text-primary has-route': Object.values(this.route).length > 0}, $vs.rtl ? 'dir-rtl' : 'dir-ltr']"
             @input="handleInputValue"
             @contextmenu="handleContextMenuClicked($event)"
             @click="handleClickInput"
             :autocomplete="'new-password'"
             :name="Math.random()"
             inputmode="numeric"
             :placeholder="placeholder || ''"
             :disabled="disabled"
             v-model="number.value">

      <div v-if="number.hasOwnProperty('checked')" class="u-input-checkbox-box">
        <u-checkbox :label="checkboxLabel || $t('global.unlimited')" :disabled="disabled" v-model="checked" @checked="handleChangeCheckbox" />
      </div>
    </div>
  </div>
</template>

<script>
import UCheckbox from '../checkBox/UCheckbox.vue'

export default {
  name: 'customNumberInput',
  components: {UCheckbox},
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    forceValue: {
      type: Boolean,
      default: false
    },
    checkboxLabel: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    labelPlaceholder: {
      type: String,
      default: ''
    },
    labelPosition: {
      type: String,
      default: 'outline',
      validator (value) {
        return ['outline', 'outside'].includes(value)
      }
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    setPageChange: {
      type: Boolean,
      default: () => { return true }
    },
    inValid: {
      type: Boolean,
      default: () => { return false }
    },
    hasComma: {
      type: Boolean,
      default: false
    },
    route: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {
      type: Object,
      default () {
        return {
          value: '',
          isValid: true
        }
      }
    },
    maxLength: {
      type: Number,
      default: () => { return 0 }
    },
    classes: {
      type: [Object, Array, String],
      default () {
        return {}
      }
    },
    styles: {
      type: Object,
      default () {
        return {}
      }
    },
    min: {
      type: Number,
      default () {
        return -1
      }
    },
    max: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  data () {
    return {
      checked: false,
      number: {
        value: '',
        isValid: false
      }
    }
  },
  computed: {
    getStyles () {
      const styles = JSON.parse(JSON.stringify(this.styles))
      // if (!styles.width) {
      //   styles.width = '230px'
      // }

      return styles
    },
    isInputDisable () {
      return this.disabled || (this.number.hasOwnProperty('checked') && this.checked)
    }
  },
  created () {
    if (Object.keys(this.value).length) {
      this.initValues()
    }
    if (this.isEmpty) {
      this.number.isValid = true
    }
  },
  methods: {
    handleInputValue () {
      if (this.forceValue) {
        this.number.value = this.value.value
      } else {
        if (this.hasComma) this.addComma()
        else this.number.value = this.number.value.toString().replace(/\D/g, '')
        this.validateValue()
        if (this.setPageChange) {
          this.$store.dispatch('setPageChanges')
        }
        const emitValue = {value: this.number.value.toString().replaceAll(',', ''), isValid: this.number.isValid}
        if (this.number.hasOwnProperty('checked')) {
          emitValue.checked = this.checked
        }
        this.$emit('input', emitValue)
      }
    },
    validateValue () {
      if (this.min !== -1 && this.max !== -1) {
        this.number.isValid = this.$u.parseFloat(this.number.value || '0') >= this.min && this.$u.parseFloat(this.number.value || '0') <= this.max
      } else if (this.isEmpty) {
        this.number.isValid = true
      } else {
        this.number.isValid = this.number.value.toString().length > 0
      }
    },
    addComma () {
      this.number.value = this.$u.priceFormat(this.number.value)
    },
    initValues () {
      this.number.value = this.hasComma ? this.$u.priceFormat(this.value.value) : (this.value.value || '').toString().replace(/\D/g, '')
      if (this.value.hasOwnProperty('checked')) {
        this.number.checked = this.value.checked
        this.checked = this.value.checked
      }
      this.validateValue()
    },
    handleContextMenuClicked (event) {
      const payload = {
        actions: {
          clipboard: this.number.value,
          paste: true
        },
        event
      }
      this.$store.dispatch('helper/contextMenuClicked', payload)
    },
    handleChangeCheckbox () {
      this.number.value = ''
      this.handleInputValue()
    },
    handleClickInput () {
      if (Object.values(this.route).length > 0) {
        window.open(this.$router.resolve(this.route).href, '_blank')
      } else {
        this.$emit('clicked')
      }
    }
  },
  watch: {
    'value': {
      handler () {
        this.initValues()
      },
      deep: true
    },

    'number.value': {
      handler (val, prev) {
        if (this.maxLength > 0 && val.length >= this.maxLength) {
          this.number.value = prev
          const emitValue = {value: this.number.value.toString().replaceAll(',', ''), isValid: this.number.isValid}
          if (this.number.hasOwnProperty('checked')) {
            emitValue.checked = this.checked
          }
          this.$emit('input', emitValue)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-number-input {
  position: relative;

  label {
    display: block;
    padding: 6px 10px 6px 5px;
    border-radius: .5rem;
    transition: all .3s ease;

    &.is-not-valid {
      border-color: #b00000;
      color: #b00000;

      input {
        color: #b00000;
      }
    }

    span {
      padding: 0 5px;
      -webkit-transition: all .3s ease;
      -moz-transition: all .3s ease;
      -o-transition: all .3s ease;
      -ms-transition: all .3s ease;
      transition: all .3s ease;
    }

    input,
    .disable-input-value {
      width: 100%;
      min-height: 21px;
      background: transparent;
      border: none;
      outline: none !important;

      &.dir-rtl {
        direction: rtl;
      }

      &.dir-ltr {
        direction: ltr;
      }
    }

    .disable-input-value {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
